import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const ScrollToHash = () => {
  const { pathname, hash, key } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = hash.replace('#', '');
      let attempts = 0;
      const maxAttempts = 10;
      
      const executeScroll = () => {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
          return true; // Found and scrolled
        }
        return false;
      };

      // Try immediately
      if (!executeScroll()) {
        // If not found, retry every 200ms up to maxAttempts (2 seconds total)
        const interval = setInterval(() => {
          attempts++;
          if (executeScroll() || attempts >= maxAttempts) {
            clearInterval(interval);
          }
        }, 200);
        return () => clearInterval(interval);
      }
    } else {
      // Find the scrollable container. Since main has overflow-y-auto, scroll that.
      const mainContainer = document.querySelector('main.overflow-y-auto');
      if (mainContainer) {
        mainContainer.scrollTo({ top: 0, behavior: 'auto' });
      } else {
        window.scrollTo(0, 0);
      }
    }
  }, [pathname, hash, key]);

  return null;
};
